namespace Matrix {
    export interface TableExcelExportRequest extends Serenity.ServiceRequest {
        Columns?: TableExcelExportColumn[];
        Data?: { [key: string]: any }[];
    }
}
